<template>
  <span class="slight"> <i :class="className"></i> {{ text }} </span>
</template>
<script src="./index.js"></script>
